import React, { useEffect, useRef, useState  } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import Popup from '../../components/Popup';

import friendlybook from '../../assets/images/friendlybook.png';

function Module17() {

  // Page nav control
  const { canContinue, setCanContinue } = usePageControl();
  
  useEffect(() => {
    setCanContinue(false);
  }, [setCanContinue]);

  const handleSuccess = () => {
    setCanContinue(true);
  };

  // Popup
  const [showPopup, setShowPopup] = useState(false);

  // - Manual popup trigger using class
  useEffect(() => {
    const triggers = document.querySelectorAll('.popup-trigger');
    triggers.forEach(trigger =>
      trigger.addEventListener('click', () => setShowPopup(true))
    );

    return () => {
      triggers.forEach(trigger =>
        trigger.removeEventListener('click', () => setShowPopup(true))
      );
    };
  }, []);
  
  // Set is a message evidence
  const [isEvidence, setIsEvidence] = useState(false); // default false
  
  const handleClickEvidenceTrue = () => {
    setIsEvidence(true);
  };
  
    // Toggle table rows
  const [openRows, setOpenRows] = useState({
    1: false,
    2: false,
    3: false,
  });

  const toggleRow = (rowId) => {
    setOpenRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  // Timer adjust
  const { timeRemaining, formatTime, addPenalty, isRunning } = useTimer();
    
  const handleDecrease = () => {
    addPenalty();  // defaults to 1 minute or addPenalty(2) for a 2-minute penalty
  };

  // Determine additional classes dynamically
  let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 


    // Go to next page
    const { goNext } = usePageControl();

  return (
    <div id="module-17" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div id="box-wrapper-email">

                    <div id="email-client">
                      <div id="email-client-header"><h1 id="email-client-header-title">Email</h1></div>
                      <div id="email-client-body">
                        <div id="email-client-sidebar"><h2 id="email-client-sidebar-title">Inbox</h2></div>
                        <div id="email-client-content">
 <table id="email-table">
      <thead>
        <tr>
          <th className="email-table-td-padding">To</th>
          <th className="email-table-td-padding">Subject</th>
          <th className="email-table-td-padding">Received</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3].map((id) => (
          <React.Fragment key={id}>
            <tr
              id={`email-table-row-${id}`}
              className={openRows[id] ? "email-table-row-open" : "email-table-row-closed"}
              onClick={() => toggleRow(id)}
              /*style={{ cursor: "pointer" }}*/
            >
              <td>
                <div className="email-table-td-padding">
                    <span className="arrow"></span>
                    {id === 1 ? "Shadow" : id === 2 ? "IT Support" : "Mum"}
                </div>
              </td>
              <td>
                <div className="email-table-td-padding">
                    {id === 1
                    ? "Show me the money!"
                    : id === 2
                    ? "Computer says No"
                    : "Don't forget to..."}
                </div>
              </td>
              <td>
                <div className="email-table-td-padding">
                    {id === 1
                    ? "1 day ago"
                    : id === 2
                    ? "2 days ago"
                    : "3 days ago"}
                </div>
              </td>
            </tr>
            <tr
              id={`email-table-row-dropdown-${id}`}
              className={`email-table-row-dropdown ${
                openRows[id] ? "open" : ""
              }`}
            >
              <td colSpan={3}>
                <div className="email-table-row-wrapper">
                    <div className="email-table-td-padding">
                {id === 1 && (
                  <>
                    <p>
                        I've hacked the account and posted what you wanted. Now where's my money!!? 5k in Crypto to following address; aHR0cHM6Ly93d3cueW91dHViZS5jb20vd2F0Y2g/dj1kUXc0dzlXZ1hjUQ==
                    </p>
                    {/* <button className="btn btn-email ml-0 popup-trigger" onClick={() => { handleClickEvidenceTrue(); handleSuccess(); } }>Select</button> */}
                    {/* Client request: Go to the next page immediately if answer is correct (3 of 3) */}
                    <button className="btn btn-email ml-0 popup-trigger" onClick={() => { goNext(); } }>Select</button>
                  </>
                )}
                {id === 2 && (
                  <>
                    <p>
                        Hey, are you able to look at my laptop sometime, I'm having some real issues with it.
                    </p>
                    <button className="btn btn-email ml-0  popup-trigger" onClick={() => { handleDecrease(); }}>Select</button>
                  </>
                )}
                {id === 3 && (
                  <>
                    <p>
                        Don't forget to feed Washington when you get home!
                    </p>
                    <button className="btn btn-email ml-0 popup-trigger" onClick={() => { handleDecrease(); } }>Select</button>
                  </>
                )}
                
                    </div>
                </div>
              </td>
            </tr>
          </React.Fragment>
        ))}
      </tbody>
    </table>     

                      </div>
                    </div>

                    </div>
                        
                    </div>

                {isEvidence &&  (

      <Popup
        title="Correct Choice!"
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        footer={
        <>
          <button className="btn" onClick={() => setShowPopup(false)}>Close</button>
        </>
        }
      >
        <p><strong>Well done!<br/>You selected the correct message as evidence.</strong></p>
        <p>The Crown Prosecution Service will be happy.</p>
        <p>You can now continue.</p>
      </Popup>

                )}

                {!isEvidence &&  (

      <Popup
        title="Wrong Choice!"
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        footer={
        <>
          <button className="btn" onClick={() => setShowPopup(false)}>Close</button>
        </>
        }
      >
        <p><strong>You have selected a message with no evidence!<br/>The Crown Prosecution Service will not be happy.</strong></p>
        <p>One minute has been deducted.</p>
        <p>Please try again!</p>
      </Popup>

                )}



                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module17;
